import { render, staticRenderFns } from "./p02.vue?vue&type=template&id=70b3d4e0&scoped=true&"
import script from "./p02.vue?vue&type=script&lang=js&"
export * from "./p02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3d4e0",
  null
  
)

export default component.exports